import apiInstance, { apiInstanceFranceIdentite } from "shared/api/axiosConfig";
import axios from "shared/api/axiosConfig";
import { decryptApiBodyToJson, encryptApiBodyFromString } from "shared/api/cryptApiBody";

// eslint-disable-next-line react-hooks/rules-of-hooks

export async function login(email, password, isNewUserFromWordpressAccompaniment= false, offreIdFromWordpress= 0) {
    try {
        let data = { email: encryptApiBodyFromString(email), password: encryptApiBodyFromString(password) };
        if (isNewUserFromWordpressAccompaniment && offreIdFromWordpress !== 0) {
            data = {
                ...data,
                isNewUserFromWordpressAccompaniment: encryptApiBodyFromString(isNewUserFromWordpressAccompaniment?.toString()),
                offreIdFromWordpress: encryptApiBodyFromString(offreIdFromWordpress?.toString())
            }
        }
        const response = await apiInstance.post(`/client/${!+(process.env.REACT_APP_FOR_PARTNER_ONLY || 0) ? 'login-with-2fa' : 'login'}`,
            { ...data },
        );

        localStorage.setItem("type", decryptApiBodyToJson(response.data).type);
        return decryptApiBodyToJson(response.data);
	} catch (error) {
		// console.log(error)
        return error;
    }
}

export async function logout() {
    try {
        const response = await apiInstance.get("/logout");
        if (response) {
			localStorage.removeItem("type");
        }
    } catch (e) {
        console.log(e);
    }
}

export async function getUser(type) {
    try {
        const response = await apiInstance.post("/client/account", { type });
        return decryptApiBodyToJson(response.data);
    } catch (error) {
        return error;
    }
}




export async function userConfirmation(token) {
    const response = await axios.post("/client/confirmation", { token: token });
    return response.data;
}

export async function checkPassword(id, password, type) {
    const url = "/client/checkPassword";
    let data = {
        type,
        id: encryptApiBodyFromString(id.toString()),
        password: encryptApiBodyFromString(password)
    };

    return axios.post(url, data);
}

// export async function userConfirmation (token) {
//   const body = new FormData()
//   body.append('token', token)
//   const response = await this.$axios.$post('/api/client/confirmation', body)
//   if (response) {
//     return response
//   }
// }

export async function loginWithSSO() {
    try {
        const baseUrl = apiInstance.getUri();
        window.location.href = `${baseUrl}/client/auth/sso`
    } catch (error) {
        // console.log(error)
        return error;
    }
}

export async function loginWithFranceIdentite() {
    try {
        const baseUrl = apiInstanceFranceIdentite.getUri();
        window.location.href = `${baseUrl}/auth/franceconnect`
    } catch (error) {
        // console.log(error)
        return error;
    }
}


export async function checkStillConnected(type, token='') {
    try {
        const response = await apiInstance.post("/client/check_still_connected", { type });
        // S'il y a bien un code 200, on retourne true
        return response.status === 200;
    } catch (error) {
        //on appel aussi
        if (token) {
            try {
                const response = await apiInstance.post("/login-with-token", { token });
                // S'il y a bien un code 200, on retourne true
                return response.status === 200;
            } catch (error) {
                return false;
            }
        }
        // En cas d'erreur, on retourne false
        return false;
    }
}


